import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import SideRail from "@/components/SideRail";

export default function PublicLayout() {
  return (
    <div className="pz-public min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <SideRail />
      <WhatsAppButton />
    </div>
  );
}
